import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import HeaderContent from './HeaderContent';
import { Button, Modal, Select, Radio } from 'antd';
import { useDispatch } from 'react-redux';
import { updatePage } from '../ApphomeActions';
const { Option } = Select;
const ApprovalsContent = (props) => {
  const { apphome, hideCustomizeButtons } = props;
  const dispatch = useDispatch();
  const [showCustomizeDataModal, setShowCustomizeDataModal] = useState(false);
  const handleCustomize = () => {
    setShowCustomizeDataModal(true);
  };
  const [orderByType, setOrderByType] = useState('created_date');
  const [order, setOrder] = useState('desc');
  const handleOk = () => {
    try {
      const data = {
        customizeConfiguration: {
          orderByType,
          order,
        },
      };
      dispatch(
        updatePage(props.match.params.wId, apphome._id, apphome.pageView, data)
      );
      setShowCustomizeDataModal(false);
    } catch (error) {
      console.error(error);
      setShowCustomizeDataModal(false);
    }
  };
  useEffect(() => {
    const page =
      apphome && apphome.pages.find((page) => page._id === apphome.pageView);
    const customizeConfiguration = page && page.customizeConfiguration;
    if (customizeConfiguration && customizeConfiguration.orderByType) {
      setOrderByType(customizeConfiguration.orderByType);
    }
    if (customizeConfiguration && customizeConfiguration.order) {
      setOrder(customizeConfiguration.order);
    }
  }, [apphome]);
  return (
    <div>
      {showCustomizeDataModal && (
        <Modal
          width={600}
          title='Customize data'
          okText='Save'
          visible={true}
          onOk={handleOk}
          onCancel={() => setShowCustomizeDataModal(false)}
        >
          <div style={{ display: 'flex', margin: '16px', gap: '32px' }}>
            <div style={{ paddingTop: '5px' }}>Order By</div>
            <div>
              <div>
                <Select
                  value={orderByType}
                  style={{ width: '213px' }}
                  onChange={(value) => setOrderByType(value)}
                >
                  <Option value='created_date'>Created date</Option>
                </Select>
              </div>
              <div style={{ marginTop: '21px' }}>
                <Radio.Group
                  onChange={(event) => setOrder(event.target.value)}
                  value={order}
                >
                  <Radio value='asce'>Ascending</Radio>
                  <Radio value='desc'>Descending</Radio>
                </Radio.Group>
              </div>
            </div>
          </div>
        </Modal>
      )}
      <HeaderContent
        title='My Approvals'
        buttonName='Customize data'
        buttonType='common'
        handleCustomize={handleCustomize}
        hideCustomizeButtons={hideCustomizeButtons}
      />
      <div
        style={{
          paddingTop: '16px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <a style={{ fontSize: '16px' }} to='#'>
              P1-5
            </a>
            <div style={{ fontSize: '14px', color: '#E01E5A' }}>
              Waiting for Approval
            </div>
            <div style={{ fontSize: '16px' }}>Summary Text</div>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', marginTop: '20px', gap: '8px' }}>
        <Button
          className='apphome-display-btn'
          style={{
            color: '#007A5A',
            width: '85px',
            height: '32px',
            borderRadius: '4px',
            padding: '4px 15px 4px 15px',
          }}
        >
          Approve
        </Button>
        <Button
          className='apphome-display-btn'
          style={{
            width: '85px',
            height: '32px',
            borderRadius: '4px',
            padding: '4px 15px 4px 15px',
          }}
        >
          Decline
        </Button>
      </div>
    </div>
  );
};

export default withRouter(ApprovalsContent);
